export default __webpack_public_path__ + "static/media/broadcastBot.ebcf7b7e.png";